import { render, staticRenderFns } from "./UnderwriterManage.vue?vue&type=template&id=708fc7e6&"
import script from "./UnderwriterManage.vue?vue&type=script&lang=js&"
export * from "./UnderwriterManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports